<div class="insurance__wrapper">
	<h3>Datos del tomador</h3>

	@for (item of items(); track item.title) {
		@if (item.text && item.text !== 'null') {
			<app-resume-item
				[title]="item.title"
				[text]="item.text" />
		}
	}
</div>
